import { useState } from "react";

import { IconButton } from "../Button/IconButton";
import { RoundButton } from "../Button/RoundButton";

interface FloatingPromoBarProps {
	className?: string;
	imageSrc?: string;
	message?: string;
	buttonText?: string;
	onButtonClick?: () => void;
	onClose?: () => void;
}

export function FloatingPromoBar({
	className = "",
	imageSrc = "",
	message = "打造你的專屬的籃球 Highlight，馬上開始！",
	buttonText = "Try inJoy App",
	onButtonClick,
	onClose,
}: FloatingPromoBarProps) {
	const [isClosing, setIsClosing] = useState(false);

	const handleClose = () => {
		setIsClosing(true);
		setTimeout(() => {
			onClose?.();
		}, 500);
	};

	return (
		<div
			className={`fixed z-30 left-1/2 -translate-x-1/2 content-stretch flex gap-[10px] items-center p-3 lg:p-5 w-[calc(100%-40px)] lg:w-full max-w-[800px] transition-all duration-500 ${
				isClosing ? "opacity-0 translate-y-4" : "opacity-100 translate-y-0"
			} ${className}`}
			style={{
				borderRadius: "var(--Radius-Radius_3, 8px)",
				border:
					"1px solid var(--Color-Alias-Border-color_border_grey_1, #DFDFDF)",
				background: "var(--Color-Alias-Global-White, #FFF)",
				boxShadow: "2px 2px 10px 0 rgba(0, 0, 0, 0.08)",
			}}
		>
			<div className="content-stretch flex flex-[1_0_0] gap-2 items-center min-h-px min-w-px relative">
				<img
					className="h-8 lg:h-10"
					src={
						imageSrc === ""
							? `${import.meta.env.VITE_APP_WEBSITE_URL}/img/event-page/game_info_thumbnail.png`
							: imageSrc
					}
					alt="promo thumbnail"
				/>
				<p
					className="flex-[1_0_0] font-medium leading-[1.35] min-h-px min-w-px relative text-[#404040] text-sm lg:text-[16px] whitespace-pre-wrap text-balance"
					style={{ fontVariationSettings: "'wdth' 100" }}
				>
					{message}
				</p>
			</div>
			<div className="hidden lg:block">
				<RoundButton type="Primary" onClick={onButtonClick}>
					{buttonText}
				</RoundButton>
			</div>
			<IconButton
				type="Tertiary"
				size="Small"
				icon="cross_outline_black"
				iconSize="Medium"
				onClick={handleClose}
			/>
		</div>
	);
}
